import { defineStore } from 'pinia';
import type { GetConfigFn } from '../types';
import { storageLocal } from '@klondpay/utils';

// 默认配置获取函数
let getConfig: GetConfigFn = () => ({
  EpThemeColor: '#409eff',
  Theme: 'light',
});

/**
 * 设置配置获取函数
 */
export function setEpThemeConfig(configFn: GetConfigFn) {
  getConfig = configFn;
}

export const useEpThemeStore = defineStore({
  id: 'vue3-admin-epTheme',
  state: () => ({
    epThemeColor:
      storageLocal.getItem('responsive-layout')?.epThemeColor ?? getConfig().EpThemeColor,
    epTheme: storageLocal.getItem('responsive-layout')?.theme ?? getConfig().Theme,
  }),
  getters: {
    getEpThemeColor(): string {
      return this.epThemeColor;
    },
    // 用于mix导航模式下hamburger-svg的fill属性
    fill(): string {
      if (this.epTheme === 'light') {
        return '#409eff';
      } else if (this.epTheme === 'yellow') {
        return '#d25f00';
      } else {
        return '#fff';
      }
    },
  },
  actions: {
    setEpThemeColor(newColor: string) {
      const layout = storageLocal.getItem('responsive-layout');
      this.epTheme = layout?.theme;
      this.epThemeColor = newColor;
      layout.epThemeColor = newColor;
      storageLocal.setItem('responsive-layout', layout);
    },
  },
});

// 导出快捷 hook
export const useEpThemeStoreHook = () => useEpThemeStore();

// 导出 hook 函数创建器
export function createEpThemeStoreHook(store: any) {
  return function () {
    return useEpThemeStore(store);
  };
}
